import { z } from 'zod';
export const factorCodeSchema = z.string().trim().min(6).max(64);
export const mfaLoginSchema = z
    .object({ challengeId: z.string().min(32).max(128), code: factorCodeSchema })
    .strict();
export const mfaSetupSchema = z
    .object({ password: z.string().min(1).max(200), code: factorCodeSchema.optional() })
    .strict();
export const mfaConfirmSchema = z.object({ code: factorCodeSchema }).strict();
export const mfaChangeSchema = mfaSetupSchema.extend({ code: factorCodeSchema });
export const mfaEnrollmentSchema = z
    .object({
    challengeId: z.string().min(32).max(128),
    code: z
        .string()
        .regex(/^\d{6}$/)
        .optional()
})
    .strict();
//# sourceMappingURL=security.js.map